(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("frameworkUtil", [], factory);
	else if(typeof exports === 'object')
		exports["frameworkUtil"] = factory();
	else
		root["frameworkUtil"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Convert__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DateUtil__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PermissionUtil__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CommonApi__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DictUtil__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ApiService__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Helper_js__ = __webpack_require__(7);







/* harmony default export */ __webpack_exports__["default"] = ({ Convert: __WEBPACK_IMPORTED_MODULE_0__Convert__, DateUtil: __WEBPACK_IMPORTED_MODULE_1__DateUtil__, PermissionUtil: __WEBPACK_IMPORTED_MODULE_2__PermissionUtil__, CommonUtil: __WEBPACK_IMPORTED_MODULE_3__CommonApi__, DictUtil: __WEBPACK_IMPORTED_MODULE_4__DictUtil__, ApiService: __WEBPACK_IMPORTED_MODULE_5__ApiService__, Helper: __WEBPACK_IMPORTED_MODULE_6__Helper_js__ });

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["toInt"] = toInt;
/* harmony export (immutable) */ __webpack_exports__["toFix"] = toFix;
function toInt(obj, defaultValue) {
	if (!obj) {
		return defaultValue;
	}
	return parseInt(obj, 10);
}

/**
 * @param {Object} obj数值
 * @param {Object} num 保留小数位数
 */
function toFix(obj, num, defaultValue) {
	if (obj) {
		obj = parseFloat(obj);
		return obj.toFixed(num);
	}
	if (defaultValue) {
		return defaultValue;
	}
	return obj;
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateUtil", function() { return DateUtil; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateUtil = function () {
	function DateUtil() {
		_classCallCheck(this, DateUtil);
	}

	_createClass(DateUtil, [{
		key: 'isLeapYear',

		/**
   * 判断闰年
   * @param date Date日期对象
   * @return boolean true 或false
   */
		value: function isLeapYear(date) {
			return 0 == date.getYear() % 4 && (date.getYear() % 100 != 0 || date.getYear() % 400 == 0);
		}
		/**
   * 获取当前日期
   */

	}, {
		key: 'getCurrentDate',
		value: function getCurrentDate() {
			return new Date();
		}
		/**
   * 日期对象转换为指定格式的字符串
   * @param f 日期格式,格式定义如下 yyyy-MM-dd HH:mm:ss
   * @param date Date日期对象, 如果缺省，则为当前时间
   *
   * YYYY/yyyy/YY/yy 表示年份
   * MM/M 月份
   * W/w 星期
   * dd/DD/d/D 日期
   * hh/HH/h/H 时间
   * mm/m 分钟
   * ss/SS/s/S 秒
   * @return string 指定格式的时间字符串
   */

	}, {
		key: 'formatDate',
		value: function formatDate(date) {
			return this.format(date, 'yyyy-MM-dd');
		}
		/**
   * 日期对象转换为指定格式的字符串
   * @param f 日期格式,格式定义如下 yyyy-MM-dd HH:mm:ss
   * @param date Date日期对象, 如果缺省，则为当前时间
   *
   * YYYY/yyyy/YY/yy 表示年份
   * MM/M 月份
   * W/w 星期
   * dd/DD/d/D 日期
   * hh/HH/h/H 时间
   * mm/m 分钟
   * ss/SS/s/S 秒
   * @return string 指定格式的时间字符串
   */

	}, {
		key: 'format',
		value: function format(date, formatStr) {
			formatStr = arguments[1] || "yyyy-MM-dd HH:mm:ss";
			date = arguments[0] || new Date();
			var str = formatStr;
			var Week = ['日', '一', '二', '三', '四', '五', '六'];
			str = str.replace(/yyyy|YYYY/, date.getFullYear());
			str = str.replace(/yy|YY/, date.getYear() % 100 > 9 ? (date.getYear() % 100).toString() : '0' + date.getYear() % 100);
			str = str.replace(/MM/, date.getMonth() >= 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1));
			str = str.replace(/M/g, date.getMonth());
			str = str.replace(/w|W/g, Week[date.getDay()]);

			str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
			str = str.replace(/d|D/g, date.getDate());

			str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
			str = str.replace(/h|H/g, date.getHours());
			str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
			str = str.replace(/m/g, date.getMinutes());

			str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
			str = str.replace(/s|S/g, date.getSeconds());

			return str;
		}
	}, {
		key: 'dateAdd',
		value: function dateAdd(date, num) {
			return this.dateCau('d', num, date);
		}

		/**
  * 日期计算
  * @param strInterval string  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
  * @param num int
  * @param date Date 日期对象
  * @return Date 返回日期对象
  */

	}, {
		key: 'dateCau',
		value: function dateCau(strInterval, num, date) {
			date = arguments[2] || new Date();
			switch (strInterval) {
				case 's':
					return new Date(date.getTime() + 1000 * num);
				case 'n':
					return new Date(date.getTime() + 60000 * num);
				case 'h':
					return new Date(date.getTime() + 3600000 * num);
				case 'd':
					return new Date(date.getTime() + 86400000 * num);
				case 'w':
					return new Date(date.getTime() + 86400000 * 7 * num);
				case 'm':
					return new Date(date.getFullYear(), date.getMonth() + num, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
				case 'y':
					return new Date(date.getFullYear() + num, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
			}
		}

		/**
  * 比较日期差 dtEnd 格式为日期型或者有效日期格式字符串
  * @param strInterval string  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
  * @param dtStart Date  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
  * @param dtEnd Date  可选值 y 年 m月 d日 w星期 ww周 h时 n分 s秒
  */

	}, {
		key: 'dateDiff',
		value: function dateDiff(strInterval, dtStart, dtEnd) {
			switch (strInterval) {
				case 's':
					return parseInt((dtEnd - dtStart) / 1000);
				case 'n':
					return parseInt((dtEnd - dtStart) / 60000);
				case 'h':
					return parseInt((dtEnd - dtStart) / 3600000);
				case 'd':
					return parseInt((dtEnd - dtStart) / 86400000);
				case 'w':
					return parseInt((dtEnd - dtStart) / (86400000 * 7));
				case 'm':
					return dtEnd.getMonth() + 1 + (dtEnd.getFullYear() - dtStart.getFullYear()) * 12 - (dtStart.getMonth() + 1);
				case 'y':
					return dtEnd.getFullYear() - dtStart.getFullYear();
			}
		}

		/**
  * 字符串转换为日期对象
  * @param date Date 格式为yyyy-MM-dd HH:mm:ss，必须按年月日时分秒的顺序，中间分隔符不限制
  */

	}, {
		key: 'strToDate',
		value: function strToDate(dateStr) {
			var data = dateStr;
			var reCat = /(\d{1,4})/gm;
			var t = data.match(reCat);
			t[1] = t[1] - 1;
			eval('var d = new Date(' + t.join(',') + ');');
			return d;
		}

		/**
  * 把指定格式的字符串转换为日期对象yyyy-MM-dd HH:mm:ss
  *
  */

	}, {
		key: 'strFormatToDate',
		value: function strFormatToDate(formatStr, dateStr) {
			var year = 0;
			var start = -1;
			var len = dateStr.length;
			if ((start = formatStr.indexOf('yyyy')) > -1 && start < len) {
				year = dateStr.substr(start, 4);
			}
			var month = 0;
			if ((start = formatStr.indexOf('MM')) > -1 && start < len) {
				month = parseInt(dateStr.substr(start, 2)) - 1;
			}
			var day = 0;
			if ((start = formatStr.indexOf('dd')) > -1 && start < len) {
				day = parseInt(dateStr.substr(start, 2));
			}
			var hour = 0;
			if (((start = formatStr.indexOf('HH')) > -1 || (start = formatStr.indexOf('hh')) > 1) && start < len) {
				hour = parseInt(dateStr.substr(start, 2));
			}
			var minute = 0;
			if ((start = formatStr.indexOf('mm')) > -1 && start < len) {
				minute = dateStr.substr(start, 2);
			}
			var second = 0;
			if ((start = formatStr.indexOf('ss')) > -1 && start < len) {
				second = dateStr.substr(start, 2);
			}
			return new Date(year, month, day, hour, minute, second);
		}

		/**
  * 日期对象转换为毫秒数
  */

	}, {
		key: 'dateToLong',
		value: function dateToLong(date) {
			return date.getTime();
		}

		/**
  * 毫秒转换为日期对象
  * @param dateVal number 日期的毫秒数
  */

	}, {
		key: 'longToDate',
		value: function longToDate(dateVal) {
			return new Date(dateVal);
		}

		/**
  * 判断字符串是否为日期格式
  * @param str string 字符串
  * @param formatStr string 日期格式， 如下 yyyy-MM-dd
  */

	}, {
		key: 'isDate',
		value: function isDate(str, formatStr) {
			if (formatStr == null) {
				formatStr = "yyyyMMdd";
			}
			var yIndex = formatStr.indexOf("yyyy");
			if (yIndex == -1) {
				return false;
			}
			var year = str.substring(yIndex, yIndex + 4);
			var mIndex = formatStr.indexOf("MM");
			if (mIndex == -1) {
				return false;
			}
			var month = str.substring(mIndex, mIndex + 2);
			var dIndex = formatStr.indexOf("dd");
			if (dIndex == -1) {
				return false;
			}
			var day = str.substring(dIndex, dIndex + 2);
			if (!this.isNumber(year) || year > "2100" || year < "1900") {
				return false;
			}
			if (!this.isNumber(month) || month > "12" || month < "01") {
				return false;
			}
			if (day > this.getMaxDay(year, month) || day < "01") {
				return false;
			}
			return true;
		}
	}, {
		key: 'getMaxDay',
		value: function getMaxDay(year, month) {
			if (month == 4 || month == 6 || month == 9 || month == 11) return "30";
			if (month == 2) if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) return "29";else return "28";
			return "31";
		}
		/**
  *    变量是否为数字
  */

	}, {
		key: 'isNumber',
		value: function isNumber(str) {
			var regExp = /^\d+$/g;
			return regExp.test(str);
		}

		/**
  * 把日期分割成数组 [年、月、日、时、分、秒]
  */

	}, {
		key: 'toArray',
		value: function toArray(myDate) {
			myDate = arguments[0] || new Date();
			var myArray = Array();
			myArray[0] = myDate.getFullYear();
			myArray[1] = myDate.getMonth();
			myArray[2] = myDate.getDate();
			myArray[3] = myDate.getHours();
			myArray[4] = myDate.getMinutes();
			myArray[5] = myDate.getSeconds();
			return myArray;
		}

		/**
  * 取得日期数据信息
  * 参数 interval 表示数据类型
  * y 年 M月 d日 w星期 ww周 h时 n分 s秒
  */

	}, {
		key: 'datePart',
		value: function datePart(interval, myDate) {
			myDate = arguments[1] || new Date();
			var partStr = '';
			var Week = ['日', '一', '二', '三', '四', '五', '六'];
			switch (interval) {
				case 'y':
					partStr = myDate.getFullYear();break;
				case 'M':
					partStr = myDate.getMonth() + 1;break;
				case 'd':
					partStr = myDate.getDate();break;
				case 'w':
					partStr = Week[myDate.getDay()];break;
				case 'ww':
					partStr = myDate.WeekNumOfYear();break;
				case 'h':
					partStr = myDate.getHours();break;
				case 'm':
					partStr = myDate.getMinutes();break;
				case 's':
					partStr = myDate.getSeconds();break;
			}
			return partStr;
		}

		/**
  * 取得当前日期所在月的最大天数
  */

	}, {
		key: 'maxDayOfDate',
		value: function maxDayOfDate(date) {
			date = arguments[0] || new Date();
			date.setDate(1);
			date.setMonth(date.getMonth() + 1);
			var time = date.getTime() - 24 * 60 * 60 * 1000;
			var newDate = new Date(time);
			return newDate.getDate();
		}
		/**
  *获取某个时间范围
   */

	}, {
		key: 'getDateRange',
		value: function getDateRange(dateNow, intervalDays, bolPastTime) {
			var oneDayTime = 24 * 60 * 60 * 1000;
			var list = [];
			var lastDay = void 0;
			var start = void 0;
			if (bolPastTime == true) {
				lastDay = new Date(dateNow.getTime() - intervalDays * oneDayTime);
				start = new Date(dateNow.getTime() - oneDayTime);
				list.push(this.formateDate(lastDay));
				list.push(this.formateDate(start));
			} else {
				lastDay = new Date(dateNow.getTime() + intervalDays * oneDayTime);
				start = new Date(dateNow.getTime() - oneDayTime);
				list.push(this.formateDate(lastDay));
				list.push(this.formateDate(start));
			}
			return list;
		}
		/**
   * 小于10 补0
   */

	}, {
		key: 'formateDate',
		value: function formateDate(time) {
			var year = time.getFullYear();
			var month = time.getMonth() + 1;
			var day = time.getDate();
			if (month < 10) {
				month = '0' + month;
			}
			if (day < 10) {
				day = '0' + day;
			}
			return year + '-' + month + '-' + day + '';
		}
	}]);

	return DateUtil;
}();

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["checkPermissions"] = checkPermissions;
/* harmony export (immutable) */ __webpack_exports__["checkPermission"] = checkPermission;

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/auth/directive.vue
 */
function checkPermissions(value) {
  if (value == undefined || value == null) {
    return true;
  }
  if (value && value instanceof Array && value.length > 0) {
    if (!window.customStore) {
      return false;
    }
    var permissions = window.customStore.getters && window.customStore.getters.permissions;
    var permissionRoles = value;
    if (permissions) {
      for (var i = 0; i < permissions.length; i++) {
        if (!permissions[i].permissions) {
          return false;
        }
        for (var j = 0; i < permissions[i].permissions.length; j++) {
          if (permissionRoles.includes(permissions[i])[j]) {
            return true;
          }
        }
      }
    }
    // const hasPermission = permissions.some(permission => {
    //   return permissionRoles.includes(permission)
    // })

    // if (!hasPermission) {
    //   return false
    // }
    return false;
  } else {
    console.error("need permissions! Like v-permission=\"['admin','editor']\"");
    return false;
  }
  return true;
}

function checkPermission(value) {
  if (value == undefined || value == null) {
    return true;
  }
  if (value) {
    if (!window.customStore) {
      return false;
    }
    var permissions = window.customStore.getters && window.customStore.getters.permissions;
    var permissionRoles = value;
    if (permissions) {
      for (var i = 0; i < permissions.length; i++) {
        if (!permissions[i].permissions) {
          return false;
        }
        for (var j = 0; j < permissions[i].permissions.length; j++) {
          if (permissions[i].permissions[j] == permissionRoles) {
            return true;
          }
        }
      }
    }
    // const hasPermission = permissions.some(permission => {
    //   return permissionRoles.includes(permission)
    // })

    // if (!hasPermission) {
    //   return false
    // }
    return false;
  } else {
    console.error("need permissions! Like v-permission=\"['admin','editor']\"");
    return false;
  }
  return true;
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getUrl"] = getUrl;
/* harmony export (immutable) */ __webpack_exports__["getTokenInfo"] = getTokenInfo;
/* harmony export (immutable) */ __webpack_exports__["getImagePathService"] = getImagePathService;
function getUrl() {
  return 'http://localhost:9094/wujinWeb';
}

function getTokenInfo() {
  return 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImV4cCI6MTYyODA3Mjc5NSwiaWF0IjoxNTk2NTM2Nzk1fQ.YpGCYmQwgOwxfpA12ke-uG0tlRT0pZ5ItMV1X7hcrqJS4zewft2baI6KsBgw5L3BMHmKy6rhwrTzqwCS5l2bfQ';
}

function getImagePathService(id) {
  return custemRequest({
    url: 'upload/pathaj/' + id
  });
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFormType"] = getFormType;
/* harmony export (immutable) */ __webpack_exports__["getDictConfig"] = getDictConfig;
/* harmony export (immutable) */ __webpack_exports__["getDictConfigIdService"] = getDictConfigIdService;
/* harmony export (immutable) */ __webpack_exports__["getDictList"] = getDictList;
/* harmony export (immutable) */ __webpack_exports__["getLinkList"] = getLinkList;
/* harmony export (immutable) */ __webpack_exports__["getDictIdList"] = getDictIdList;
/* harmony export (immutable) */ __webpack_exports__["getDictListByCode"] = getDictListByCode;
/* harmony export (immutable) */ __webpack_exports__["getDictTreeList"] = getDictTreeList;
/* harmony export (immutable) */ __webpack_exports__["getDictIdLinkList"] = getDictIdLinkList;
/* harmony export (immutable) */ __webpack_exports__["getUrlLinkList"] = getUrlLinkList;
/* harmony export (immutable) */ __webpack_exports__["getFilesService"] = getFilesService;
/* harmony export (immutable) */ __webpack_exports__["removeFile"] = removeFile;


function getFormType() {
  return custemRequest({
    url: 'dict/formType',
    method: 'get'
  });
}

function getDictConfig() {
  return custemRequest({
    url: 'dict/config',
    method: 'get'
  });
}

function getDictConfigIdService() {
  return custemRequest({
    url: 'dict/config/id',
    method: 'get'
  });
}

function getDictList(dictId, index) {
  return custemRequest({
    url: 'dict/list',
    method: 'get',
    params: {
      dictId: dictId,
      index: index
    }
  });
}
function getLinkList(dictId, pId, index) {
  return custemRequest({
    url: 'dict/link/list',
    method: 'get',
    params: {
      dictId: dictId,
      index: index,
      pId: pId
    }
  });
}

function getDictIdList(dictId, index) {
  return custemRequest({
    url: 'dict/list/id',
    method: 'get',
    params: {
      dictId: dictId,
      index: index
    }
  });
}

function getDictListByCode(code, index) {
  return custemRequest({
    url: 'dict/list/code',
    method: 'get',
    params: {
      code: code,
      index: index
    }
  });
}

function getDictTreeList(dictId, index) {
  return custemRequest({
    url: 'dict/listTree',
    method: 'get',
    params: {
      dictId: dictId,
      index: index
    }
  });
}

//查询子节点数据
function getDictIdLinkList(dictId, pId, index) {
  return custemRequest({
    url: 'dict/linkList/id',
    method: 'get',
    params: {
      index: index,
      dictId: dictId,
      pId: pId

    }
  });
}
function getUrlLinkList(url, pId, index) {
  return custemRequest({
    url: url,
    method: 'get',
    params: {
      index: index,
      pId: pId
    }
  });
}

function getFilesService(recordId) {
  return custemRequest({
    url: 'sysFjxxMul/getFiles',
    method: 'get',
    params: {
      'recordId': recordId
    }
  });
}

function removeFile(id, recordId) {
  return custemRequest({
    url: 'upload/remove',
    method: 'post',
    params: {
      'recordId': recordId,
      'id': id
    }
  });
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiService", function() { return ApiService; });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiService = function () {
  function ApiService(url) {
    _classCallCheck(this, ApiService);

    this.baseUrl = url;
  }

  // 获取列表数据.需要分页


  _createClass(ApiService, [{
    key: 'list',
    value: function list(query, _basicId) {
      var url = this.baseUrl + '/list';
      if (_basicId) {
        url += '/' + _basicId;
      }
      return custemRequest({
        url: url,
        method: 'get',
        params: query
      });
    }

    // 获取列表数据.不需要分页

  }, {
    key: 'all',
    value: function all(query) {
      return custemRequest({
        url: this.baseUrl + '/all',
        method: 'get',
        params: query
      });
    }
  }, {
    key: 'tree',
    value: function tree(query) {
      return custemRequest({
        url: this.baseUrl + '/tree',
        method: 'get',
        params: query
      });
    }

    // 新增数据

  }, {
    key: 'create',
    value: function create(data, _basicId) {
      var url = this.baseUrl;
      if (_basicId) {
        url += '/' + _basicId;
      }
      return custemRequest({
        url: url,
        method: 'post',
        data: data
      });
    }

    // 修改数据

  }, {
    key: 'update',
    value: function update(id, data, _basicId) {
      var url = this.baseUrl + '/' + id;
      if (_basicId) {
        url = this.baseUrl + '/' + _basicId + '/' + id;
      }
      return custemRequest({
        url: url,
        method: 'put',
        data: data
      });
    }

    // 删除数据

  }, {
    key: 'delete',
    value: function _delete(id, _basicId) {
      var url = this.baseUrl + '/' + id;
      if (_basicId) {
        url = this.baseUrl + '/' + _basicId + '/' + id;
      }
      return custemRequest({
        url: url,
        method: 'delete'
      });
    }

    // 获取数据详情

  }, {
    key: 'view',
    value: function view(id) {
      return custemRequest({
        url: this.baseUrl + '/' + id,
        method: 'get'
      });
    }
    // 获取数据详情

  }, {
    key: 'viewDisplay',
    value: function viewDisplay(id) {
      return custemRequest({
        url: this.baseUrl + '/view/' + id,
        method: 'get'
      });
    }

    // 修改或新增

  }, {
    key: 'save',
    value: function save(data) {
      return custemRequest({
        url: this.baseUrl,
        method: 'post',
        data: data
      });
    }
  }, {
    key: 'exportData',
    value: function exportData(data, basicId, token) {
      var url = this.baseUrl + "/export";
      if (basicId) {
        url += "/" + basicId;
      }
      var params = "";
      for (var value in data) {
        if (data[value]) {
          params += "&" + value + "=" + data[value];
        }
      }
      url += "?" + params;
      url += '&Authorization=' + token;
      url = window.getLocationUrl() + '/' + url;
      window.open(url);
    }

    //

  }, {
    key: 'modifyByUrl',
    value: function modifyByUrl(url, data, modelId) {
      var newUrl = this.baseUrl + '/' + url;
      if (newUrl.indexOf('?') >= 0) {
        newUrl += '&';
      } else {
        newUrl += '?';
      }
      newUrl += 'modelId=' + modelId;
      return custemRequest({
        url: newUrl,
        method: 'post',
        data: data
      });
    }
  }]);

  return ApiService;
}();

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["GetQueryString"] = GetQueryString;
/* harmony export (immutable) */ __webpack_exports__["IsImageService"] = IsImageService;
/* harmony export (immutable) */ __webpack_exports__["clearJsonValue"] = clearJsonValue;

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);return null;
}

function IsImageService(file) {
  if (!file) {
    return false;
  }
  file = file.toLowerCase();
  if (file.indexOf(".png") >= 0 || file.indexOf(".jpg") >= 0 || file.indexOf(".jpeg") >= 0 || file.indexOf("bmp") >= 0) {
    return true;
  }
  return false;
}

function clearJsonValue(data, isArrayNull) {
  if (data) {
    for (var key in data) {
      if (data[key] && data[key] instanceof Array) {
        if (isArrayNull) {
          data[key] = null;
        } else {
          data[key] = [];
        }
      } else {
        data[key] = null;
      }
    }
  }
}

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// build.js